import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/useTranslation";

const btnClass =
  "bg-brandNavy/90 hover:bg-brandNavy text-white font-semibold py-3 px-10 rounded-2xl shadow-soft transition-all duration-200 hover:shadow-card focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2";

/** Matches Login / Signup “Back” — history when possible, else home. */
const LegalDocumentTopBack: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) navigate(-1);
    else navigate("/");
  };

  return (
    <div className="mb-6 flex w-full justify-center">
      <button type="button" onClick={handleBack} className={btnClass}>
        {t("wizard.common.back")}
      </button>
    </div>
  );
};

export default LegalDocumentTopBack;
